var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tasks-container-invalid-token"},[_c('h4',[_vm._v("Sorry, you are not allowed to see this page.")])])
}]

export { render, staticRenderFns }